import { ENV_CONFIG } from '../../../../../__config__/env';
const BASE_URL = `https://cdn.reeltime.no/pm_assets/img/cards/`;
const PM_AZURE_URL = `${ENV_CONFIG.CDN_HOST}privatmegleren/`;

export const images = {
  falk_bg: {
    mobile: `${BASE_URL}falk_bg.png`,
    desktop: `${BASE_URL}falk_bg@2x.png`
  },
  ulv_bg: {
    mobile: `${BASE_URL}ulv_bg.png`,
    desktop: `${BASE_URL}ulv_bg@2x.png`
  },
  panter_bg: {
    mobile: `${PM_AZURE_URL}hva-er-din-bolig-verdt.jpg`,
    desktop: `${PM_AZURE_URL}hva-er-din-bolig-verdt.jpg`
  },
  voice_bg: {
    mobile: `${BASE_URL}voice_bg.png`,
    desktop: `${BASE_URL}voice_bg@2x.png`
  },
  kjop_bg: {
    mobile: `${BASE_URL}kjop_bg.png`,
    desktop: `${BASE_URL}kjop_bg@2x.png`
  },
  kjop_logo: {
    mobile: `${BASE_URL}kjop_logo.png`,
    desktop: `${BASE_URL}kjop_logo@2x.png`
  },
  square: {
    mobile: `${BASE_URL}square.png`,
    desktop: `${BASE_URL}square@2x.png`
  },
  mic: {
    mobile: `${BASE_URL}mic.gif`,
    desktop: `${BASE_URL}mic.gif`
  },
  verdi: {
    mobile: `${BASE_URL}PM_verdi_500x500.jpg`,
    desktop: `${BASE_URL}PM_verdi_500x500.jpg`
  },
  notis: {
    mobile: `https://cdn.reeltime.no/pm_assets/notis/notisbg.jpg`,
    desktop: `https://cdn.reeltime.no/pm_assets/notis/notisbg.jpg`
  },
  boligbytte: {
    mobile: `${BASE_URL}PM_bb_500x500.jpg`,
    desktop: `${BASE_URL}PM_bb_500x500.jpg`
  },
  spoross: {
    mobile: `${PM_AZURE_URL}spoross.jpg`,
    desktop: `${PM_AZURE_URL}spoross.jpg`
  },
  selgeKjope: {
    mobile: `${BASE_URL}PM_pm.no_500x500-1.jpg`,
    desktop: `${BASE_URL}PM_pm.no_500x500-1.jpg`
  },
  selgeKjope2: {
    mobile: `${BASE_URL}PM_pm.no_500x500-2.jpg`,
    desktop: `${BASE_URL}PM_pm.no_500x500-2.jpg`
  },
  selgeKjope3: {
    mobile: `${BASE_URL}PM_pm.no_500x500-3.jpg`,
    desktop: `${BASE_URL}PM_pm.no_500x500-3.jpg`
  },
  selgeKjope4: {
    mobile: `${BASE_URL}PM_pm.no_500x500-4.jpg`,
    desktop: `${BASE_URL}PM_pm.no_500x500-4.jpg`
  },
  nordea_finans: {
    mobile: `${BASE_URL}PM_pm.no-5.jpg`,
    desktop: `${BASE_URL}PM_pm.no-5.jpg`
  },
  sommerTaktisk: {
    mobile: `${BASE_URL}PM_sommerTaktisk_500x500.jpg`,
    desktop: `${BASE_URL}PM_sommerTaktisk_500x500.jpg`
  },
  presisjon: {
    mobile: `${PM_AZURE_URL}boligsalg-med-presisjon.jpg`,
    desktop: `${PM_AZURE_URL}boligsalg-med-presisjon.jpg`
  },
  detaljerSomSelger1: {
    mobile: `${BASE_URL}Rosa-tak.jpg`,
    desktop: `${BASE_URL}Rosa-tak.jpg`
  },
  detaljerSomSelger2: {
    mobile: `${BASE_URL}Spiraltrapp.jpg`,
    desktop: `${BASE_URL}Spiraltrapp.jpg`
  },
  detaljerSomSelger3: {
    mobile: `${BASE_URL}Tredetaljer.jpg`,
    desktop: `${BASE_URL}Tredetaljer.jpg`
  },
  presisjon2: {
    mobile: `${PM_AZURE_URL}boligsalg-med-presisjon.jpg`,
    desktop: `${PM_AZURE_URL}boligsalg-med-presisjon.jpg`
  },
  forstegangsselgeren: {
    mobile: `${PM_AZURE_URL}forstegangsselgeren-par.jpg`,
    desktop: `${PM_AZURE_URL}forstegangsselgeren-par.jpg`
  },
  forstegangsselgeren2: {
    mobile: `${PM_AZURE_URL}forstegangsselgeren-bestemor.jpg`,
    desktop: `${PM_AZURE_URL}forstegangsselgeren-bestemor.jpg`
  },
  forstegangsselgeren3: {
    mobile: `${PM_AZURE_URL}forstegangsselgeren-brodre.jpg`,
    desktop: `${PM_AZURE_URL}forstegangsselgeren-brodre.jpg`
  },
  forstegangsselgeren4: {
    mobile: `${PM_AZURE_URL}forstegangsselgeren-businessdame.jpg`,
    desktop: `${PM_AZURE_URL}forstegangsselgeren-businessdame.jpg`
  },
  kjop: {
    mobile: `${PM_AZURE_URL}skal-du-selge-bolig-ls-syrin.jpg`,
    desktop: `${PM_AZURE_URL}skal-du-selge-bolig-ls-syrin.jpg`
  },
  artikkelsideNordea: {
    mobile: `${PM_AZURE_URL}nyttig-aa-vite-til-budrunden.jpg`,
    desktop: `${PM_AZURE_URL}nyttig-aa-vite-til-budrunden.jpg`
  },
  secretProperty: {
    mobile: `${PM_AZURE_URL}secret-property1-500x500.jpg`,
    desktop: `${PM_AZURE_URL}secret-property1-500x500.jpg`
  },
  secretProperty2: {
    mobile: `${PM_AZURE_URL}secret-property2-500x500.jpg`,
    desktop: `${PM_AZURE_URL}secret-property2-500x500.jpg`
  },
  secretProperty3: {
    mobile: `${PM_AZURE_URL}secret-property3-500x500.jpg`,
    desktop: `${PM_AZURE_URL}secret-property3-500x500.jpg`
  },
  secretProperty4: {
    mobile: `${PM_AZURE_URL}secret-property4-500x500.jpg`,
    desktop: `${PM_AZURE_URL}secret-property4-500x500.jpg`
  },
  nabovett1: {
    mobile: `${PM_AZURE_URL}nabovett/Nabovett_01.jpg`,
    desktop: `${PM_AZURE_URL}nabovett/Nabovett_01.jpg`
  },
  nabovett2: {
    mobile: `${PM_AZURE_URL}nabovett/Nabovett_02.jpg`,
    desktop: `${PM_AZURE_URL}nabovett/Nabovett_02.jpg`
  },
  nabovett3: {
    mobile: `${PM_AZURE_URL}nabovett/Nabovett_03.jpg`,
    desktop: `${PM_AZURE_URL}nabovett/Nabovett_03.jpg`
  },
  nabovett4: {
    mobile: `${PM_AZURE_URL}nabovett/Nabovett_04.jpg`,
    desktop: `${PM_AZURE_URL}nabovett/Nabovett_04.jpg`
  },
  nabovett5: {
    mobile: `${PM_AZURE_URL}nabovett/Nabovett_05.jpg`,
    desktop: `${PM_AZURE_URL}nabovett/Nabovett_05.jpg`
  },
  nabovett6: {
    mobile: `${PM_AZURE_URL}nabovett/Nabovett_06.jpg`,
    desktop: `${PM_AZURE_URL}nabovett/Nabovett_06.jpg`
  }
};
